// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"_c69e842e","carouselItem":"_eb068b08","moduleContainer":"_7e8dd4b0","isFullBleed":"_71abc42e","fullWidth":"_f62f4238"};